// import EventList from "../components/eventsDisplay";
import EventsFetch from "../components/eventsFetch";
import ImageGallery from "../components/imageGallery";

function Events() {
  return (
    <>
      <EventsFetch />
      <ImageGallery />
    </>
  );
}

export default Events;
